export default __webpack_public_path__ + "static/media/IDE_Bg.28f51f87.png";